import React, { useEffect } from "react";
import { renderElement } from "../../../Components/Common/FormRendererV2/Renderer";
import { useSelector, useDispatch } from "react-redux";
import { AgMemberModalLayoutJSON } from "../Json/AgMemberLayoutJson";
import { useNavigate, useParams } from "react-router-dom";
import {
  openModal,
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../slices/common/reducer";

import {
  getDropdownListOfRM,
  readAll,
  updateAgMember,
} from "../AgMemberService";
import { checkButtonAccess, getOrgId } from "../../../Utils/CommonUtils";
import { CardBody } from "reactstrap";
import CommonButton from "../../../Components/Common/CommonButton/CommonButton";
import ConfirmationModal from "../Modal/ConfirmationModal";
import ProfileFormModal from "../Modal/ProfileFormModal";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useState } from "react";
import { setMode } from "../../../slices/agMember/agMemberSlice";

const Details = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigator = useNavigate();
  const data = useSelector(
    (state) => state.agMember.selectedAgMember.detailsData
  );
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const editMode = !!params.id;

  const agMemberFieldJson = useSelector(
    (state) => state.agMember.agMemberFieldJson
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const modalShow = useSelector((state) => state.common.modalShow);
  const storedUser = JSON.parse(localStorage.getItem("selectedUser"));
  const mode = useSelector((state) => state.agMember.mode);

  const updatedFieldsJSON = {
    ...agMemberFieldJson,
    "1718616976561-email": {
      ...agMemberFieldJson["1718616976561-email"],
      "display-disabled": editMode ? 1 : 0, // Disable when in edit mode
    },
    "1718616984561-phoneNumber": {
      ...agMemberFieldJson["1718616984561-phoneNumber"],
      "display-disabled": editMode ? 1 : 0, // Disable when in edit mode
    },
  };

  useEffect(() => {
    if (storedUser.owner_id) {
      getDropdownListOfRM(
        storedUser.owner_id,
        selectedUser.organizationid,
        agMemberFieldJson
      );
    }
  }, [storedUser.owner_id]);

  useEffect(() => {
    readAll(params.id, mode);
  }, [params.id, mode]);

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    navigator("/agmember/member");
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const confirmUpdate = () => {
    if (formState) {
      dispatch(setSelectValidError(false));
      updateAgMember(formState, params.id, navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  const openProfileForm = () => {
    dispatch(openModal(true));
  };

  const handleEditClick = () => {
    dispatch(setMode("EDIT"));
  };

  const handleView = () => {
    dispatch(setMode("VIEW"));
  };

  const renderAgmDetailsJson = () => {
    if (!data) return <p>No profile data available</p>;

    const formatDate = (value) => {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return value;
    };

    const renderChildFields = (childData) => {
      const fields = [];

      childData?.forEach((child, index) => {
        if (
          child.elementtype === "documentFile" ||
          child.elementtype === "textfield" ||
          child.elementtype === "email" ||
          child.elementtype === "customDate" ||
          child.elementtype === "number" ||
          child.elementtype === "textarea" ||
          child.elementtype === "customSelect" ||
          child.elementtype === "phoneNumber"
        ) {
          const labelKey = `${child.elementid}-${child.elementtype}`;
          const fieldLabel =
            agMemberFieldJson[labelKey]?.["display-fieldlabel"] ||
            child.elementid;
          const databaseLabel = agMemberFieldJson[labelKey]?.["database-label"];
          // let fieldValue = formState[databaseLabel];

          let fieldValue;
          if (databaseLabel === "rm_id") {
            fieldValue = formState["rm_name"];
          } else {
            fieldValue = formState[databaseLabel];
          }

          const formattedValue =
            fieldValue &&
            typeof fieldValue === "string" &&
            fieldValue.match(/^\d{4}-\d{2}-\d{2}/)
              ? formatDate(fieldValue)
              : fieldValue;

          fields.push(
            <Col span={12} className="form-view-field" key={child.elementid}>
              <div className="view-label">{fieldLabel} :</div>
              <div className="view-value">{formattedValue || "-"}</div>
            </Col>
          );
        }

        if (child.child) {
          fields.push(renderChildFields(child.child));
        }
      });

      return fields;
    };

    return (
      <div>
        <div className="proposal-container">
          <div className="form-json-view">
            {AgMemberModalLayoutJSON.map((element, ind) => {
              return (
                <Row className="form-row">
                  {element.child && renderChildFields(element.child)}
                </Row>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Form onSubmit={updateClickHandler}>
        <CardBody>
          <div className="selected-tab-bottom-content">
            {mode === "EDIT"
              ? AgMemberModalLayoutJSON.map((element) => (
                  <div key={element.elementid}>
                    {element.child.map((child) =>
                      renderElement(child, updatedFieldsJSON, formState)
                    )}
                  </div>
                ))
              : renderAgmDetailsJson()}
          </div>
          <div className="form-footer">
            <CommonButton
              handleForm={openProfileForm}
              handleCancel={handleCancel}
              form={true}
              checkAccess={checkButtonAccess("EDIT", "AGM_MEM")}
              isEditing={mode === "EDIT"}
              handleEdit={handleEditClick}
              handleView={handleView}
            />
          </div>
          {verifyShow && !modalShow && (
            <ConfirmationModal confirmUpdate={confirmUpdate} />
          )}
          {modalShow && <ProfileFormModal />}
        </CardBody>
      </Form>
    </div>
  );
};

export default Details;
